import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Domain, EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { decimal, removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import { FormCard, MainBodyCard, PagesFormTitle } from "components/Cards"
import { useModal } from "utils/context/ModalContext"
import ImageIcon from "assets/icon/ImageIcon"
import imageCompression from "browser-image-compression";
import Webcam from "react-webcam";
import { CustomerService } from "services/CustomerService/CustomerService"

export default function CustomerForm(){
    const navigate = useNavigate()

    const webcamRef = useRef(null)
    const { fetchCreateCustomer, fetchUpdateCustomer, fetchDeleteCustomer, fetchCustomerById } = CustomerService()
    const { showLoading, hideLoading, showSuccess, confirm } = useModal()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramCustomerId = queryString.get("customerId")

    const [customerName, setCustomerName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [phone, setPhone] = useState(EmptyString)
    const [idPhoto, setIdPhoto] = useState(null)
    const [idPhotoPreview, setIdPhotoPreview] = useState('')
    const [masterMdrGestun, setMasterMdrGestun] = useState(EmptyString)
    const [masterMdrPl, setMasterMdrPl] = useState(EmptyString)
    const [masterMdrPlQris, setMasterMdrPlQris] = useState(EmptyString)

    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [showWebcam, setShowWebcam] = useState(false)

    // Button Event
    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try{
                    if (formType === FormTypeAdd){
                        const res = await fetchCreateCustomer(
                            customerName.trim(), 
                            address, 
                            phone, 
                            idPhoto, 
                            masterMdrGestun, 
                            masterMdrPl, 
                            masterMdrPlQris
                        )

                        if (!res) return

                        showSuccess({
                            onSuccess: () => {
                                navigate("/customer") 
                            }
                        })
                    }else{
                        const res = await fetchUpdateCustomer(paramCustomerId, customerName.trim(), address, phone, idPhoto, masterMdrGestun, masterMdrPl, masterMdrPlQris)

                        if (!res) return

                        showSuccess({
                            onSuccess: () => {
                                navigate("/customer") 
                            }
                        })
                    }
                } finally{
                    hideLoading()
                }
            }
        }
    }
    const deleteBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try{
                const res = await fetchDeleteCustomer(paramCustomerId, status)

                if (!res) return

                showSuccess({
                    onSuccess: () => {
                        navigate("/customer") 
                    }
                })
            } finally{
                hideLoading()
            }
        }
    }
    const backBtnClick = () => {
        navigate('/customer')
    }

    function validateForm(){
        let errorCount = 0

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }
    const dataURLtoFile = (dataUrl, filename) => {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }
    const handleIdPhotoChange = async (e) => {
        const imageFile = e.target.files[0]

        if (!imageFile) return

        const MAX_SIZE = 1 * 1024 * 1024;

        try {
            let finalFile = imageFile;

            // kalau lebih dari 1MB → compress
            if (imageFile.size > MAX_SIZE) {
                const options = {
                    maxSizeMB: 1,              // target max 1MB
                    maxWidthOrHeight: 1920,   // resize jika perlu
                    useWebWorker: true,
                };

                finalFile = await imageCompression(imageFile, options);
            }

            setIdPhoto(finalFile)
            setIdPhotoPreview(URL.createObjectURL(finalFile))

        } catch (error) {
            console.error("Compression error:", error);
        }
    }
    const webcamCapture = async () => {
        const imageSrc = webcamRef.current.getScreenshot()

        if (!imageSrc) return;

        const file = dataURLtoFile(
            imageSrc,
            `webcam_${Date.now()}.jpg`
        )

        const compressedFile = await imageCompression(file, {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
        });

        setIdPhoto(compressedFile)
        setIdPhotoPreview(URL.createObjectURL(compressedFile))
    }
    const takePhotoBtnClick = () => {
        if (showWebcam) {
            webcamCapture()
        }
        else {

        }

        setShowWebcam(!showWebcam)
    }

    useEffect(() => {
        const loadCustomer = async () => {
            if (formType ===  FormTypeEdit){
                showLoading()

                try{
                    const res = await fetchCustomerById(paramCustomerId)

                    if (!res) return

                    const data = res.data
                    // const domain = 'https://' + window.location.hostname
                    // const domain = 'https://gestun-yupiter.com'
                    setCustomerName(data.customerName)
                    setAddress(data.address)
                    setPhone(data.phone)
                    setIdPhotoPreview(Domain + '/images/' + data.fileName + `?t=${Date.now()}`)
                    setMasterMdrGestun(data.masterMdrGestun)
                    setMasterMdrPl(data.masterMdrPl)
                    setMasterMdrPlQris(data.masterMdrPlQris)

                    setStatus(data.status)
                    setCreateDate(data.createDate)
                    setUpdateDate(data.updateDate)
                    setUpdateBy(data.updateBy)
                } finally{
                    hideLoading()
                }
            }
        }
        
        loadCustomer()
    }, [])

    return (
        <MainBodyCard>
            <PagesFormTitle 
                title='Detail Pelanggan'
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />

            <div className="mt-5 flex flex-col gap-3">
                <FormCard title='Nama Pelanggan'>
                    <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value.toUpperCase()) }} maxLength={100} />
                </FormCard>

                <FormCard title='Alamat'>
                    <input className="input" value={address} onChange={(e) => { setAddress(e.target.value.toUpperCase()) }} maxLength={100} />
                </FormCard>

                <FormCard title='No HP'>
                    <input className="input" value={phone} onChange={(e) => { setPhone(removeNonNumeric(e.target.value)) }} maxLength={16} />
                </FormCard>

                <FormCard title='MDR Gestun'>
                    <input className="input" value={masterMdrGestun} onChange={(e) => { setMasterMdrGestun(decimal(e.target.value)) }} maxLength={4} />
                </FormCard>

                <FormCard title='MDR PL'>
                    <input className="input" value={masterMdrPl} onChange={(e) => { setMasterMdrPl(decimal(e.target.value)) }} maxLength={4} />
                </FormCard>

                <FormCard title='MDR PL QRIS'>
                    <input className="input" value={masterMdrPlQris} onChange={(e) => { setMasterMdrPlQris(decimal(e.target.value)) }} maxLength={4} />
                </FormCard>

                <div className="flex flex-col sm:flex-row sm:items-center text-sm">
                    <div className="w-48">
                        <span>Photo ID</span>
                    </div>
                    <div className="px-4 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        {showWebcam ? (
                            <Webcam
                                audio={false}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                width={400}
                            />
                        ) : (
                            <img
                                className="w-auto h-[200px] object-cover mx-auto border rounded-md"
                                src={idPhotoPreview}
                                alt="ID"
                            />
                        )}
                        
                        <input className="hidden" id="idPhoto" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handleIdPhotoChange} />
                        <button onClick={() => document.getElementById('idPhoto').click()} 
                            className="mt-2 px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center items-center"
                        >
                            <ImageIcon />
                            Add Image
                        </button>
                        <button onClick={takePhotoBtnClick} 
                            className="mt-2 px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center items-center"
                        >
                            <ImageIcon />
                            Take Photo
                        </button>
                        {/* 
                        <br />

                        <button onClick={webcamCapture}>
                            Capture Photo
                        </button> */}

                        {/* {image && (
                            <div>
                            <h3>Captured Image</h3>
                            <img src={image} alt="Captured" width={400} />
                            </div>
                        )} */}
                    </div>
                </div>
            </div>

            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick}  />
            </div>
        </MainBodyCard>
    )
}